import { Select, Spin } from "antd";
import { changeCounsilor } from "api/counsilors";
import ConfirmChangeCouncilor from "components/Modal/ConfirmChangeCouncilor";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePickerComp from "themes/elements/DatePicker";
import ModalComp from "themes/elements/Modal";
import TextAreaComp from "themes/elements/TextArea";
import ModalFooter from "../modalFooter";

function ChangeCounsilor({
  open,
  setOpen,
  counsilors,
  seletedItem,
  setSearchInput,
  selectLoading,
}) {
  const [councillor, setCounsilor] = useState({
    councillor_data: { key: null, label: null, ward_code: null },
    startDate: "",
    endDate: "",
    reason: "",
  });

  const [localOptions, setLocalOptions] = useState([]);
  const [confirmModal, setConfirmOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [caseData, setCaseData] = useState();

  // Sync localOptions with props when props change
  useEffect(() => {
    setLocalOptions(counsilors || []);
  }, [counsilors]);

  // Reset form when modal opens
  useEffect(() => {
    if (open) {
      setCounsilor({
        councillor_data: { key: null, label: null, ward_code: null },
        startDate: "",
        endDate: "",
        reason: "",
      });
    }
  }, [open]);

  const handleChange = (field, value) => {
    setCounsilor({ ...councillor, [field]: value });
  };

  const isValid = () => {
    return (
      councillor.councillor_data.key &&
      councillor.startDate &&
      councillor.endDate &&
      councillor.reason.trim() !== ""
    );
  };

  const handleFormSave = async (verified = false) => {
    if (!isValid()) {
      toast.warn("Please fill all the fields.");
      return;
    }

    const isVerified = typeof verified === "boolean" ? verified : false;

    if (!isVerified) {
      if (
        seletedItem.councilor_map_ward_id &&
        councillor?.councillor_data?.ward_code
      ) {
        setConfirmOpen(true);
        setCaseData(3);
        return;
      } else if (seletedItem.councilor_map_ward_id) {
        setConfirmOpen(true);
        setCaseData(1);
        return;
      } else if (councillor?.councillor_data?.ward_code) {
        setConfirmOpen(true);
        setCaseData(2);
        return;
      }
    }

    await submitChange();
  };

  const submitChange = async () => {
    setLoading(true);
    try {
      const res = await changeCounsilor({
        wardCode: String(seletedItem?.ward),
        councilorId: councillor?.councillor_data?.key,
        termStartDate: councillor?.startDate,
        termEndDate: councillor?.endDate,
        mapStatusFlg: 2,
        reason: councillor?.reason,
        regionId: seletedItem?.region_id,
        regionName: seletedItem?.region_name,
      });

      if (res) {
        toast.success(res?.message);
        setOpen(false);
        setConfirmOpen(false);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleChangeDate = (field, value) => {
    if (dayjs(value, "DD-MM-YYYY").isValid()) {
      const formattedDate = dayjs(value, "DD-MM-YYYY").format("YYYY-MM-DD");
      setCounsilor((prev) => ({ ...prev, [field]: formattedDate }));
    }
  };

  return (
    <>
      <ModalComp
        title={seletedItem.councillor ? "Change councillor" : "Add councillor"}
        footer={
          <ModalFooter
            handlePrimaryBtn={() => setOpen(false)}
            handleSecondaryBtn={handleFormSave}
            secondaryBtnLoading={!caseData ? loading : false}
            primaryBtnText="Cancel"
            secondaryBtnText="Save"
            primaryBtnVariant="secondary"
          />
        }
        open={open}
        setOpen={setOpen}
      >
        <div className="flex gap-4 flex-column overflow-scroll">
          <div className="flex flex-column w-full">
            <label className="input-label mb-2">New councillor</label>
            <Select
              showSearch
              loading={selectLoading}
              notFoundContent={
                selectLoading ? <Spin size="small" /> : "No councillor found"
              }
              className="chip-select-search color-select"
              style={{ width: "100%" }}
              popupClassName="select-popover color-select-popover"
              value={councillor.councillor_data.key}
              onSearch={(inputValue) => setSearchInput(inputValue)}
              onChange={(value, option) => {
                const selectedCouncillor = localOptions.find(
                  (c) => c.key === value
                );
                handleChange("councillor_data", {
                  key: value,
                  label: option.children,
                  ward_code: selectedCouncillor?.ward_code || null,
                });
              }}
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              placeholder="Select a councillor"
            >
              {localOptions.map((c) => (
                <Select.Option key={c.key} value={c.key}>
                  {c.label}
                </Select.Option>
              ))}
            </Select>
          </div>

          <div className="flex gap-4 align-center">
            <div className="flex flex-column w-full">
              <label className="input-label mb-2">Start of term</label>
              <DatePickerComp
                format="DD-MM-YYYY"
                value={
                  councillor.startDate
                    ? dayjs(councillor.startDate).format("DD-MM-YYYY")
                    : null
                }
                onChange={(date) => handleChangeDate("startDate", date)}
              />
            </div>
            <div className="flex flex-column w-full">
              <label className="input-label mb-2">End of term</label>
              <DatePickerComp
                format="DD-MM-YYYY"
                value={
                  councillor.endDate
                    ? dayjs(councillor.endDate).format("DD-MM-YYYY")
                    : null
                }
                onChange={(date) => handleChangeDate("endDate", date)}
              />
            </div>
          </div>

          <TextAreaComp
            maxValue={200}
            layoutClass="w-full"
            value={councillor.reason}
            onChange={(e) => handleChange("reason", e.target.value)}
            placeholder="Reason"
            label="Reason"
          />
        </div>
      </ModalComp>

      <ConfirmChangeCouncilor
        handleFormSave={submitChange}
        caseData={caseData}
        loading={loading}
        open={confirmModal}
        setOpen={setConfirmOpen}
        seletedItem={seletedItem}
      />
    </>
  );
}

export default ChangeCounsilor;
